import { Alert, AlertIcon, useToast } from "@chakra-ui/react";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { ContextApp } from "../../shared/ContextApp";

export const useUnauthorizedAction = () => {
  const { user, setUser } = useContext(ContextApp);
  const navigate = useNavigate();
  const toast = useToast();
  const userRequiredForThisAction = () => {
    return (
      <>
        <Alert status="info">
          <AlertIcon />
          Usted no está logueado
        </Alert>
      </>
    );
  };

  const action = () => {
    setUser(undefined);
    toast({
      duration: 2800,
      position: "top",
      render: () => userRequiredForThisAction(),
    });
    navigate("/");
  };
  return { action };
};
